import {
	StartPage,
	AboutPage,
	HochbauPage,
	TiefbauPage,
	DetailsPage,
	KontaktPage,
	JobsPage,
	FAQsPage,
	ImpressumPage,
	DatenschutzPage,
	ErrorPage,
} from "../pages";

export const NavList = [
	{
		path: "/",
		component: StartPage,
		linkText: "Start",
	},
	{
		path: "/about",
		component: AboutPage,
		linkText: "Über uns",
	},
	{
		path: "/hochbau",
		component: HochbauPage,
		linkText: "Hochbau",
	},
	{
		path: "/tiefbau",
		component: TiefbauPage,
		linkText: "Tiefbau",
	},
	{
		path: "/jobs",
		component: JobsPage,
		linkText: "Jobs",
	},
	{
		path: "/kontakt",
		component: KontaktPage,
		linkText: "Kontakt",
	},
];

export const FooterNavList = [
	{
		path: "/faqs",
		component: FAQsPage,
		linkText: "FAQs",
	},
	{
		path: "/impressum",
		component: ImpressumPage,
		linkText: "Impressum",
	},
	{
		path: "/datenschutz",
		component: DatenschutzPage,
		linkText: "Datenschutz",
	},
];

export const AdditonalRoutes = [
	{
		path: "/details",
		component: DetailsPage,
	},
	{
		path: "*",
		component: ErrorPage,
	},
];

export const BusinessInformations = {
	Unternehmen: "ECO² Building",
	Strasse: "Kennedyallee 93",
	PLZ: "60596",
	Ort: "Frankfurt am Main",
	Telefon: "069/26024889",
	Email: "info@eco2-building.de",
	steuerNr: "folgt..",
	UstIdNr: "folgt...",
	Handelsregister: "131355",
	Registergericht: "Frankfurt am Main",
	Geschäftsführer: "Zakaria El Gouy und Tamim Mahbub",
	VertretungDurch: "Zakaria El Gouy und Tamim Mahbub",
	Entwicklung: "ilkerrr.de",
	Design: "ilkerrr.de",
};
